$( function () {
	let el = $( '.insights-section .insights-section__slider' );
	const buttonInsSect = document.querySelector('.view-all-button');
	if (buttonInsSect) {
		buttonInsSect.addEventListener('click', ()=>{
			const linkInsUrl = $('.insights-section__header > a').attr('href');

			if (linkInsUrl) window.open(linkInsUrl, '_self');
		})
	}

	function init( el ) {
		el.on( 'init', function () {
			setDelay( this );
			el.find('.insights-slider__item > a').attr('tabindex', -1);
            el.find('.insights-slider__item.slick-active > a').attr('tabindex', 0);
		} );

		const SLIDER = initCustonSliderNav( el, $( '.insights-section .slider-nav-dots' ), {
			dots: false,
			arrows: true,
			infinite: false,
			speed: 500,
			slidesToShow: 1.1,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 3000,
			mobileFirst: true,
			accessibility: false,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						dots: true,
						prevArrow: $('.prev-insights'),
						nextArrow: $('.next-insights'),
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						dots: true,
						prevArrow: $('.prev-insights'),
						nextArrow: $('.next-insights'),
					}
				},
			]
		} );

		SLIDER.on( 'afterChange', function () {
			$( this ).find( '.insights-slider__divider' ).removeClass( 'active' ).css( {animationDelay: ''} );
			setTimeout( () => setDelay( this ), 20 );
			SLIDER.find('.insights-slider__item > a').attr('tabindex', -1);
            SLIDER.find('.insights-slider__item.slick-active > a').attr('tabindex', 0);
		} );

		const section = $( '.insights-section' );
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: 0.1
		};
		const observer = new IntersectionObserver( onEntry, options );

		observer.observe( section.get( 0 ) );

		function onEntry( entry ) {
			entry.forEach( change => {
				if ( (
					     change.boundingClientRect.y + change.boundingClientRect.height
				     ) >= window.innerHeight ) {
					section.removeClass( 'animated' );
				}

				if ( change.isIntersecting ) {
					section.addClass( 'animated' );
				}
			} );
		}

		function setDelay( context ) {
			$( context ).find( '.slick-active .insights-slider__divider' ).each( function ( index ) {
				$( this ).css( {animationDelay: index + 's'} )
			} ).addClass( 'active' );
		}
	}

	if ( el.hasClass( 'ajax-relevant-posts' ) ) {
		let post_id = el.data( 'post-id' );
		$.ajax( {
			url: window.options.ajax_url,
			data: {post_id: post_id, action: 'get_posts_random_order'},
			type: 'POST',
			success: function ( respons ) {
				el.html( respons.data );
				init( el );
			}
		} );
	} else {
		init( el );
	}
} );
